import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { ModuleSharedModule } from '../../modules/module-shared.module';
import { LimitCountersPage } from './limit-counters.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    ModuleSharedModule,
  ],
  declarations: [LimitCountersPage]
})
export class LimitCountersPageModule { }
